import { subscriptionList as EnUsSubscriptionList } from '../en-us/subscriptionList';
import { AgResourceLanguage } from '../types';

export const subscriptionList: AgResourceLanguage['subscriptionList'] = {
  ...EnUsSubscriptionList,
  showCheckboxLabel: 'Afficher uniquement les abonnements actifs',
  emptyState: {
    ...EnUsSubscriptionList.emptyState,
    title: 'Créez votre premier abonnement',
    text: `Il semble que vous n’ayez pas encore fait d’achat. Obtenez un soutien complet pour la nutrition et la santé intestinale en une seule dose facile.`,
    button: 'Obtenez votre AG1'
  },
  subscriptionCard: {
    ...EnUsSubscriptionList.subscriptionCard,
    titleOrder: 'Prochaine commande :',
    titleSubscription: 'Produits d’abonnement :',
    activeLabel: 'Actif',
    cancelLabel: 'Annulé',
    frequencyTitle: 'Fréquence :',
    frequencyDayText: 'Tous les',
    manageSubscriptionButton: 'Gérer l’abonnement',
    subscriptionDetailsButton: 'Détails de l’abonnement',
    reactivateButton: 'Réactiver',
    orderDateLabel: 'Date de commande :',
    orderTotalLabel: 'Total de la commande :',
    productsSubtitle: 'Produits :',
    subscriptionDetailsSubtitle: 'Détails de l’abonnement'
  },
  cancelList: {
    ...EnUsSubscriptionList.cancelList,
    title: 'Abonnements annulés',
    description: `Réactivez votre abonnement pour recevoir AG1 selon votre emploi du temps. Une fois votre abonnement actif, vous pourrez ajuster vos préférences et accéder à la gamme complète des produits AG1.`
  }
};
